import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { debounceTime, map, startWith, switchMap, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { UntypedFormControl, Validators } from "@angular/forms";
import { GenericComponent } from "../../components/generic.component";
import { MatOptionSelectionChange } from "@angular/material/core";
import { DriverDTO } from "../../models/driver-dto";
import { DriverAPIService } from "@core/services/driver-api.service";
import { SearchFormDTO } from "src/app/modules/private/modules/driver/search-form-dto";
import { PageManager } from "src/app/shared/models/page-manager";
import { DEFAULT_PAGINATION } from "src/app/shared/constants/default-pagination";
import { Pagination } from "src/app/shared/models/pagination";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-smartfleet-driver-auto-complete",
    templateUrl: "./driver-auto-complete.component.html",
    styleUrls: ["./driver-auto-complete.component.scss"],
    standalone: false
})
export class DriverAutoCompleteComponent
  extends GenericComponent
  implements OnInit, AfterViewInit
{
  route: ActivatedRoute;
  loading = false;
  driver = new UntypedFormControl();
  pageManager: PageManager = {
    totalElements: 0,
    pageIndex: DEFAULT_PAGINATION.PAGE_INDEX,
    pageSize: DEFAULT_PAGINATION.PAGE_SIZE_AUTOCOMPLETE
  };

  searchForm = this.fb.group({
    name: this.driver
  });

  drivers$: Observable<Pagination<DriverDTO[]>>;

  @Input() page: string;
  @Input() title = "";
  @Input() requiredText = "";
  @Input() ignoreDriverWithVehicleId = "";
  @Input() clientId;
  @Input() set required(value: boolean) {
    if (value && !this.disabled) {
      this.searchForm.controls.name.setValidators([Validators.required]);
    }
  }
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<DriverDTO>();

  constructor(
    private driverAPIService: DriverAPIService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.drivers$ = this.driver.valueChanges.pipe(
      startWith(""),
      debounceTime(200),
      tap(
        () => (
          (this.loading = true), this.loadingDrivebService.setAutoMode(false)
        )
      ),
      switchMap((value: string) => {
        if (value) {
          const searchForm = {} as SearchFormDTO;
          searchForm.nameAndUsername = value.toUpperCase();
          searchForm.clientId = this.clientId;
          searchForm.ignoreDriverWithVehicleId = this.ignoreDriverWithVehicleId;
          return this.driverAPIService.findByFilters(
            searchForm,
            this.pageManager,
            ""
          );
        } else {
          this.onChange.emit({} as DriverDTO);
          return of({}) as Observable<Pagination<DriverDTO[]>>;
        }
      }),
      map((result) => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        return result;
      })
    );
  }

  ngAfterViewInit(): void {
    this.setFilters();
  }

  handleDriverChange(event: MatOptionSelectionChange, driver: DriverDTO) {
    if (event.isUserInput === true) {
      this.onChange.emit(driver);
    }
  }

  clean(): void {
    this.searchForm.reset();
  }

  private setFilters() {
    //verifica a pagina em que o autocomplete esta inserido
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "vehicle-model":
          key = "vm-driverId";
          break;
        case "vehicle":
          key = "vc-driverId";
          break;
        case "my-fleet":
          key = "my-fleet-driverId";
          break;
        case "maintenance-plan":
          key = "mp-driverId";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const driver = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(
          `${driver["name"]} - ${driver["username"]}`
        );
      }
    } else {
      this.clean();
    }
  }
}
